export const RADIO_INPUT_VALIDATION_CLASSES = {
  warning: 'd-radio--warning',
  error: 'd-radio--error',
  success: 'd-radio--success',
};

export default {
  RADIO_INPUT_VALIDATION_CLASSES,
};
